import React, { useContext, useState } from "react";
import { SignInPage } from "./signin-page";
import { MeContext } from "../../contexts/me-context/me-context";
import { api } from "../../services/api";
import { createAction } from "../../services/create-action";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export const SignInFactory = () => {
  const { t } = useTranslation('auth');
  const { setMe } = useContext(MeContext);
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const failSearchRole = () => {
      toast.error(t('signIn.failSearchRole'));
      localStorage.clear();
  };

  const signInWithEmail = ({ email = "", password = "" }) => {
      setIsLoading(true);
      console.log("Attempting login to:", api.defaults.baseURL);
    return api
      .post("/sign-in", { email: email.trim(), password: password.trim()})
      .then(({ data: dataUser }) => {
          console.log("Login Response Data:", dataUser);
          if(dataUser.role !== "admin"){
              toast.warning(t('signIn.accessDenied', { role: dataUser.role }));
              throw new Error("Acesso Negado");
          }
        localStorage.setItem("user", JSON.stringify(dataUser));
        setMe(dataUser);
        createAction({ action: "USER_SIGN_IN", name: dataUser.name });
        toast.success(t('signIn.loginSuccess'));
      })
      .catch((e) => {
        console.error("Login Error Object:", e);
        throw e;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <SignInPage
      loading={isLoading}
      onSignInEmail={signInWithEmail}
    />
  );
};
